<template>
  <div class="training_table">
    <div class="padding">
      <div class="return_box">
        <el-button @click="back">返回</el-button>
        <p>创建操作考核>{{ $route.query.type == 0 ? "新增" : "编辑" }}评分表</p>
      </div>
      <Bar :barList="barList" :active="active" />
    </div>
    <main>
      <div class="main_view">
        <keep-alive>
          <one
            v-if="
              (active == 0 && $route.query.type == 0) ||
              (active == 0 && state == 1)
            "
            ref="one"
            :editorObj="editorObj"
            @ruleObj="getPropertyObj"
          />
          <Two v-if="active == 1" ref="two" :parameter="parameter"/>
        </keep-alive>
      </div>
      <div class="button_view" :class="active == 0 ? '' : 'fixed'">
        <el-button @click="backType(0)" v-if="$route.query.type !=1">{{
          active == 0 ? "返回" : "上一步"
        }}</el-button>
        <el-button @click="backType(1)" :loading="sundflag">{{
          active == 1 ? "保存评分表" : "下一步"
        }}</el-button>
      </div>
    </main>
  </div>
</template>

<script>
import Bar from "@/components/progress/Bar.vue";
import One from "./One.vue";
import Two from "./Two.vue";
export default {
  data() {
    return {
      barList: [
        {
          id: "0",
          lable: "评分表名称及性质",
        },
        {
          id: "1",
          lable: "评分表内容",
        },
      ],
      active: 0, // 用于控制第几步进度
      state: 0, // 编辑确保拿到数据
      parameter: {}, // 传参
      editorObj: {}, // 编辑详情
      sundflag: false, // 防抖
    };
  },
  methods: {
    // 返回
    back() {
      this.$router.push({
        path: "/operationCheck/scoreTable", //跳转的路径
      });
      if (this.$route.query.type == 1) {
        this.$storage.sessionRemove("rowObj");
      }
      this.$destroy();
    },
    backType(type) {
      //  type 0 上一步 1下一步 active 当前所在
      if (type == 0 && this.active == 0) {
        this.back();
      } else if (type == 1 && this.active == 0) {
        this.$refs.one.submitForm(); // 正则校验
        console.log("保存组件一");
      } else if (type == 1 && this.active == 1) {
        this.$refs.two.setSaveData(); // 正则校验
        // console.log("提交");
      } else if (type == 0) {
        this.active--;
      } else if (type == 1) {
        this.active++;
      }
    },
    getPropertyObj(row) {
      this.parameter = row;
      console.log(this.parameter, "????");
    },
  },
  components: {
    Bar,
    One,
    Two,
  },
  created() {
     if(this.$route.query.type == 1){
       this.active = 1 // 编辑没有第一步，不允许修改表格类型
     }
  },
};
</script>

<style lang="scss" scoped>
.training_table {
  height: 100%;
  width: 100%;
  min-height: 740px;
  background-color: #fff;
  border-radius: 0px 0px 4px 4px;
}
.padding {
  padding: 30px 36px 0px 36px;
  // margin-bottom: 30px;
}
.return_box {
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  .el-button {
    // width: 56px;
    height: 40px;
    background: #f6f6f6;
    border: 1px solid #dfdfdf;
    border-radius: 2px;
    margin-right: 30px;
  }
}
main {
  display: flex;
  flex-direction: column;
  min-height: 580px;
  position: relative;
  .main_view {
    flex: 1;
    margin: 30px 36px 0px 36px;
  }
  .button_view {
    // width: 100%;
    flex: 0 0 110px;
    border-top: 1px solid #eeeef0;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-button {
      width: 112px;
      height: 40px;
      background: #ebecf1;
      border-radius: 3px;
      &:nth-child(1) {
        margin-right: 20px;
      }
    }
  }
}
.fixed {
  position: fixed;
  left: 50%;
  bottom: 5%;
  transform: translate(-5%, -5%);
  border-top: none !important;
}
</style>
